import React from 'react';
import PropTypes from 'prop-types';

const NavigationMenu = ({ menuItems }) => {
  const handleClick = (e, item) => {
    e.preventDefault();
    console.log(item);
  };

  return (
    <ul className="navbar-nav gap-xl-5 gap-4 mx-auto py-xl-0 py-4 pb-2">
      {menuItems.map((item) => (
        <li
          key={item.id}
          className={`nav-item ${item.subMenu ? "dropdown" : ""}`}
        >
          {item.subMenu ? (
            <>
              <a
                href="#"
                className="nav-link text-gray-darker p-0 d-flex align-items-center"
                onClick={(e) => handleClick(e, item)}  
              >
                {item.title}{" "}
                <i className="fas fa-caret-down small ms-2"></i>
              </a>
              <ul className="dropdown-menu border-0 shadow-sm rounded-3">
                {item.subMenu.map((subItem) => (
                  <li key={subItem.id}>
                    <a href={subItem.url} className="dropdown-item">
                      {subItem.title}
                    </a>
                  </li>
                ))}
              </ul>
            </>
          ) : (
            <a
              className="nav-link text-gray-darker p-0"
              href={item.url}
            >
              {item.title}
            </a>
          )}
        </li>
      ))}
    </ul>
  );
};

NavigationMenu.propTypes = {
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
      title: PropTypes.string.isRequired,
      url: PropTypes.string,
      componentName: PropTypes.string,
      subMenu: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
          title: PropTypes.string.isRequired,
          url: PropTypes.string.isRequired,
          componentName: PropTypes.string.isRequired,
        })
      ),
    })
  ).isRequired,
};

export default NavigationMenu; 